<template>
  <div>
    <mds-row>
      <mds-col :class="$style['main-header']">{{ title }} </mds-col>
      <mds-col v-if="primaryButtonConfig.visible" :class="$style['apply-button']">
        <mds-button
          type="button"
          variation="primary"
          :disabled="primaryButtonConfig.disabled"
          :text="primaryButtonConfig.text"
          @click="onPrimaryButtonClicked"
        >
        </mds-button>
      </mds-col>
    </mds-row>
    <mds-row>
      <mds-col>
        {{ description }}
      </mds-col>
    </mds-row>
  </div>
</template>

<script>
import { MdsRow, MdsCol } from '@mds/layout-grid';
import { MdsButton } from '@mds/button';

export default {
  name: 'fee-schedule-list-panel-header',
  components: {
    MdsRow,
    MdsCol,
    MdsButton,
  },
  props: {
    title: String,
    description: String,
    primaryButtonConfig: {
      type: Object,
      default: () => ({
        text: '',
        visible: true,
        disabled: false,
      }),
    },
  },
  methods: {
    onPrimaryButtonClicked(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss" module>
@import '@mds/constants';
@import '@mds/typography';
.main-header {
  @include mds-body-text-l();
}
.apply-button {
  display: flex;
  justify-content: flex-end;
  margin-top: $mds-space-1-x;
}
</style>
